<template>
  <va-card>
    <div class="row">
      <div class="flex xs12" :class="{xl6: isFullScreen}">
        <users-select :label="$t('users.notification.selectusers')" v-model="users" :disabledSelectUser="disabledSelectUser"/>
        <va-input class="mb-0" :label="$t('users.notification.title')" v-model="title"></va-input>
      </div>
      <div class="flex xs12" :class="{xl6:isFullScreen}">
        <message-area :label="$t('users.notification.message')" v-model="message" />
        <va-button :disabled="!isValid" @click="submitForm">{{$t('users.notification.submit')}}</va-button>
      </div>
    </div>
  </va-card>
</template>
<script>
import UsersSelect from './UsersSelect.vue'
import MessageArea from './MessageArea.vue'
export default {
  data() {
    return {
      users: this.defaultUsers,
      title: '',
      message: '',
    }
  },
  computed: {
    isValid() {
      return (this.message !== '' && this.title !== '' && this.users.length > 0)
    },
  },
  methods: {
    submitForm() {
      if (this.users.includes(-1)) {
        this.users = []
      }
      this.$emit('submit', { users: this.users, title: this.title, message: this.message })
      this.users = this.defaultUsers
      this.title = ''
      this.message = ''
    },
  },
  props: {
    defaultUsers: {
      type: Array,
      default: () => [-1],
    },
    isFullScreen: {
      type: Boolean,
      default: () => true,
    },
    disabledSelectUser: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    MessageArea,
    UsersSelect,
  },
  created() {
    this.users = this.defaultUsers
  },
}

</script>
<style>

</style>
